import React from "react";
import logoNew from "../../../assets/logo-new.png";
import logoCollapsed from "../../../assets/logo-collapsed.png";
import "./skeleton.css";
import { readSidebarCollapsed } from "../Sidebar/sidebarState";

const NAV_LABEL_WIDTHS = ["58%", "72%", "64%", "80%", "52%"];
const FOOTER_LABEL_WIDTHS = ["34%", "46%", "42%"];

const SkeletonItem = ({ compact, labelWidth, glyph = 36 }) => (
  <div className="sk-sidebar-item">
    <div
      className="sk"
      style={{ width: glyph, height: glyph, flex: `0 0 ${glyph}px`, borderRadius: 10 }}
    />
    {!compact && <div className="sk" style={{ height: 12, width: labelWidth }} />}
  </div>
);

// Matches the live sidebar's width, spacing and sections so the swap to the
// real navigation does not shift anything.
// Without an explicit state (e.g. the full-page loader), fall back to the
// persisted pin state so a reload renders the same width as the live sidebar.
const SidebarSkeleton = ({ isCollapsed = readSidebarCollapsed() }) => (
  <div
    className={`sk-sidebar ${isCollapsed ? "sk-sidebar--compact" : ""}`}
    style={{ width: isCollapsed ? 82 : 300 }}
    aria-busy="true"
    aria-label="Loading navigation"
  >
    <div className="sk-sidebar-logo">
      <img
        src={isCollapsed ? logoCollapsed : logoNew}
        alt="EMAlpha"
        style={{
          height: 50,
          width: isCollapsed ? 40 : 190,
          objectFit: "contain",
        }}
      />
    </div>

    <div className="sk-sidebar-toggle">
      <div className="sk" style={{ width: 36, height: 36, borderRadius: "50%" }} />
    </div>

    <div className="sk-sidebar-nav">
      {NAV_LABEL_WIDTHS.map((width) => (
        <SkeletonItem key={width} compact={isCollapsed} labelWidth={width} />
      ))}
    </div>

    <div className="sk-sidebar-footer">
      {FOOTER_LABEL_WIDTHS.map((width) => (
        <SkeletonItem key={width} compact={isCollapsed} labelWidth={width} glyph={28} />
      ))}
    </div>
  </div>
);

export default SidebarSkeleton;
